// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Avatar = registerClientReference(
    function() { throw new Error("Attempted to call Avatar() from the server but Avatar is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/avatar.tsx <module evaluation>",
    "Avatar",
);
export const AvatarFallback = registerClientReference(
    function() { throw new Error("Attempted to call AvatarFallback() from the server but AvatarFallback is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/avatar.tsx <module evaluation>",
    "AvatarFallback",
);
export const AvatarImage = registerClientReference(
    function() { throw new Error("Attempted to call AvatarImage() from the server but AvatarImage is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ui/avatar.tsx <module evaluation>",
    "AvatarImage",
);
